export enum EmployeeTypeEnum {
	INTERNAL = 'Primários',
	THIRD_PARTY = 'Terceiros',
}
export interface ActivityPoleConditionData {
	id: number;
	employeeType: EmployeeTypeEnum;

	activityPoleConditionTrainings: {
		id: number;
		training: {
			id: number;
			name: string;
			trainingType: string;
		};
	}[];
}

export interface ActivityData {
	id: number;
	name: string;
	description: string;
	activityPoles: {
		id: number;
		activityPoleConditions: ActivityPoleConditionData[];
		pole: {
			id: number;
			name: string;
		};
	}[];
}
